import userApi from "./index"

export const submitReport = async (detail, screenshot, questionId) => {
  try {
    const formData = new FormData()
    formData.append("detail", detail)
    if (screenshot) {
      formData.append("screenshot", screenshot)
    }
    if (questionId) {
      formData.append("questionId", questionId)
    }

    const response = await userApi.post("/reports", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}
